<template>
  <nav class="navbar navbar-expand-lg bg-white shadow-sm py-0 sticky-top">
    <div
      class="container-fluid container d-flex flex-row justify-content-between align-items-center"
    >
      <router-link class="navbar-brand" to="/"
        ><img class="logo" src="@/assets/images/logo.webp" alt=""
      /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link" aria-current="page" href="#"
              >Administration</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              to="/clinical-research"
              class="nav-link"
              aria-current="page"
              href="#"
              >Clinical Trials</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/clinical-lab"
              class="nav-link"
              aria-current="page"
              href="#"
              >Clinical Lab</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/data-science" class="nav-link" href="#"
              >Data Science</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/research-fellows" class="nav-link"
              >Research Fellows</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/research-officers" class="nav-link"
              >Research Officers</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "KhrcNavbar",
};
</script>
<style scoped>
.logo {
  height: 60px;
}
</style>
